module.exports = __webpack_public_path__ + "assets/img/logo-wechat.10893cf8.jpg";